import { useEffect } from 'react';
import closeModal from 'Helpers/ModalHelper';
import useCollection from 'Hooks/useCollection';
import { QueryVal, removeQuery } from 'Helpers/Query';
import fr from 'facet-rest';
import typeMetaOverrides from 'Overrides/typeMetaOverrides';
import {
  displaySuccess,
  displayErrorMessage,
} from 'Helpers/FacetNotificationManager';

export default function useLinkModal({
  link,
  type,
  onSubmit,
  onSubmitMessage = 'Save successful',
}) {
  const { collection, setCollection } = useCollection();
  const linkUrl = QueryVal(link);

  const handleClose = () => {
    closeModal();
    removeQuery(link);
  };

  const loadCollection = async () => {
    if (!link) {
      return;
    }

    if (!(type in typeMetaOverrides)) {
      throw new Error(`Resource type ${type} not in type meta overrides`);
    }

    try {
      const coll = await fr.http.get(linkUrl);
      if (coll.resources().length() === 0) {
        coll.create({
          addToCollection: true,
        });
      }

      let collectionWithOverride = coll;
      const metaOverrideSet = typeMetaOverrides[type];
      if (metaOverrideSet) {
        collectionWithOverride = coll.overrideMeta(metaOverrideSet);
      }
      setCollection(collectionWithOverride);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  useEffect(() => {
    loadCollection();
  }, [linkUrl]);

  const onSuccess = () => {
    displaySuccess(onSubmitMessage);
    if (onSubmit) {
      onSubmit();
    }
    handleClose();
  };

  const onFailure = (err) => {
    displayErrorMessage(err, err.errors);
  };

  return {
    collection,
    handleClose,
    onSuccess,
    onFailure,
  };
}
